export default __webpack_public_path__ + "static/about-img-5ab1b205c4d320cc894b47139a1ba677.jpeg";